import React from "react";
import { createRoot } from "react-dom/client";

import NewsEventsAndMediaOverview from "./react-components/pages/NewsEventsAndMediaOverview";
import BlogsOverview from "./react-components/pages/BlogsOverview";

import EventFeedback from "./react-components/pages/Events/EventFeedback";

import Publications from "./react-components/pages/Publications/Publications";
import PublicationsByThemes from "./react-components/pages/Publications/PublicationsByThemes";
import PublicationsByRegionOrCountry from "./react-components/pages/Publications/PublicationsByRegionOrCountry";
import PublicationFeedback from "./react-components/pages/Publications/PublicationFeedback";

import Newsletters from "./react-components/pages/Newsletters";
import Partners from "./react-components/pages/Partners";

import PeopleOverview from "./react-components/pages/People/PeopleOverview";
import MediaExpert from "./react-components/pages/People/MediaExpert";

import ProcurementAwardReports from "./react-components/pages/Tenders/ProcurementAwardReports";
import ClosedTenders from "./react-components/pages/Tenders/ClosedTenders";

import YearDropdownDownloads from "./react-components/pages/YearDropdownDownloads";
import ContactForm from "./react-components/pages/ContactForm";

// Governance
import MeetingsOverview from "./react-components/pages/Governance/MeetingsOverview";
import ReferenceDocOverview from "./react-components/pages/Governance/ReferenceDocOverview";

import Projects from "./react-components/pages/Projects";

import DataToolFeedback from "./react-components/pages/DatabaseTools/DataToolFeedback";
import StateOfDemocracyContact from "./react-components/pages/DatabaseTools/StateOfDemocracyContact";
import RequestKeyERMTool from "./react-components/pages/DatabaseTools/RequestKeyERMTool";
import RequestKeyITAS from "./react-components/pages/DatabaseTools/RequestKeyITAS";
import ERMToolITASDownload from "./react-components/pages/DatabaseTools/ERMToolITASDownload";
import AdvancedSearch from "./react-components/pages/DatabaseTools/AdvancedSearch";

import HazardMonitor from "./react-components/pages/ElectionDashboard/HazardMonitor";
import GlobalElectionMonitor from "./react-components/pages/ElectionDashboard/GlobalElectionMonitor";

const listOfContainers = {
  "#news-events-media-overview-container": <NewsEventsAndMediaOverview />,
  "#blogs-overview-container": <BlogsOverview />,
  "#democracy-notes-overview-container": <BlogsOverview />,
  "#event-feedback-container": <EventFeedback />,

  "#publications-container": <Publications />,
  "#publications-by-themes-container": <PublicationsByThemes />,
  "#publications-by-region-container": <PublicationsByRegionOrCountry />,
  "#publications-by-country-container": <PublicationsByRegionOrCountry />,
  "#publication-feedback-container": <PublicationFeedback />,

  "#newsletters-container": <Newsletters />,
  ".partners-container": <Partners />,
  "#media-expert-container": <MediaExpert />,
  "#our-people-container": <PeopleOverview />,
  "#procurement-award-reports-container": <ProcurementAwardReports />,
  "#closed-tenders-container": <ClosedTenders />,
  ".year-dropdown-downloads-container": <YearDropdownDownloads />,
  "#contact-container": <ContactForm />,
  "#meetings-overview-container": <MeetingsOverview />,
  "#reference-documents-overview-container": <ReferenceDocOverview />,
  "#projects-container": <Projects />,

  "#datatool-feedback-container": <DataToolFeedback />,
  "#sod-contact-container": <StateOfDemocracyContact />,
  "#requestkey-ermtool-container": <RequestKeyERMTool />,
  "#requestkey-itas-container": <RequestKeyITAS />,
  ".tool-download-form-container": <ERMToolITASDownload />,
  "#advanced-search-container": <AdvancedSearch />,

  "#election-dashboard-hazard-monitor-container": <HazardMonitor />,
  "#election-dashboard-global-election-monitor-container": <GlobalElectionMonitor />,
};

Object.keys(listOfContainers).forEach((containerName) => {
  const containerElements = document.querySelectorAll(containerName);

  if (containerElements.length > 0) {
    containerElements.forEach((containerElm) => {
      const dataAttributes = containerElm
        .getAttributeNames()
        .filter((attributeName) => attributeName.startsWith("data-"))
        .reduce((result, attributeName) => {
          const key = attributeName.slice(5); // Remove "data-" prefix
          const value = containerElm.getAttribute(attributeName);
          result[key] = value;
          return result;
        }, {});

      const component = listOfContainers[containerName];

      if (component) {
        // add data attributes as props to the component
        const props = { data: dataAttributes };
        listOfContainers[containerName] = React.cloneElement(component, props);
        // console.log(containerName, props);
      } else {
        console.warn(`Component not found for container "${containerName}"`);
      }

      // create a new root and render the component
      const rootElm = document.createElement("div");
      containerElm.appendChild(rootElm);
      const root = createRoot(rootElm);
      root.render(listOfContainers[containerName]);
    });
  }
});
